import { styled } from "styled-components";

export const Screen = styled.div``;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100dvh;
  gap: ${({ theme }) => theme.spacing[6]};
`;

export const Spinner = styled.span`
  width: 48px;
  height: 48px;
  border-radius: 50%;
  display: inline-block;
  position: relative;
  border: 3px solid;
  border-color: #fff #fff transparent;
  box-sizing: border-box;
  animation: spinnerRotation 1s linear infinite;

  &:after {
    content: "";
    box-sizing: border-box;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    border: 3px solid;
    border-color: ${({ theme }) =>
      `transparent ${theme.colors.background.grundfos.primary} ${theme.colors.background.grundfos.primary}`};
    width: 24px;
    height: 24px;
    border-radius: 50%;
    animation: spinnerRotationBack 0.5s linear infinite;
    transform-origin: center center;
  }
`;

export const Title = styled.div`
  font-weight: 700;
  font-size: 24px;
`;
